import {
    createSlice,
    createAsyncThunk,
    PayloadAction
} from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import {
    getExistWolesaleAccountServices
} from 'services/RequestDataService';

export type ExistWolesaleAccountServicesPayload = {
    accountId: number;
    accountServiceIds: number[];
  };

export const fetchExistWolesaleAccountServices= createAsyncThunk(
    'getExistWolesaleAccountServices',
    async (payload: ExistWolesaleAccountServicesPayload) => {
        return await getExistWolesaleAccountServices(payload.accountId, payload.accountServiceIds);
    });

type ExistWolesaleAccountServicesState = {
    [key: number]: number[]
}

const initialState: ExistWolesaleAccountServicesState = [];

const existWolesaleAccountServicesSlice = createSlice({
    name: 'existWolesaleAccountServices',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(fetchExistWolesaleAccountServices.fulfilled, (state, action) => {

            if (action?.payload?.success !== true) {

                return;
            }

            return {
                ...state,
                [action.meta.arg.accountId]: action.payload.data ?? []
            };
        })
    },
});

export default existWolesaleAccountServicesSlice.reducer;

export const getCurrentAccountExistWolesaleAccountServices = (state: RootState) =>
    state?.user?.data?.currentAccount?.accountId
        ? state.existWolesaleAccountServices[state.user.data.currentAccount.accountId]
        : undefined;
